import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import MaterialUIGroupedMultiSelect from "../../../common/selects/MaterialUIGroupedMultiSelect";

export default function ServiceGroupsFilter({selectedServiceGroups, handleChangeFilterData, inputStyle, label='Группы сервисов'}) {

    let {subscriptionServiceGroups} = useSelector(state => state.filterDataReducer.filterData);

    const [dropdownData, setDropdownData] = useState([]);

    useEffect(() => {
        if (!subscriptionServiceGroups || subscriptionServiceGroups.length === 0) {
            return;
        }
        const dropdownData1 = subscriptionServiceGroups
            .filter(dataItem => (dataItem.subscriptionServices && dataItem.subscriptionServices.length > 0))
            .map(dataItem => {
            return {...dataItem,
                options: dataItem.subscriptionServices.map(service => {return {...service, fullName: service.externalId + ' | ' + service.name}})}
        });
        setDropdownData(dropdownData1);
    }, [subscriptionServiceGroups]);


    const onSelect = (value) => {
        handleChangeFilterData && handleChangeFilterData("serviceGroups", value, true);
    };

    return (
        <MaterialUIGroupedMultiSelect
            styles={inputStyle}
            dropdownData={dropdownData}
            groupDisplayedField='name'
            groupDataField='id'
            values={selectedServiceGroups}
            dataField='externalId'
            displayedField='fullName'
            label={label}
            placeholder={'-'}
            onSelect={onSelect}
            isSearchable
        />
    );
}